import { render, staticRenderFns } from "./IntroduceBlock.vue?vue&type=template&id=6d6bd9af&scoped=true"
import script from "./IntroduceBlock.vue?vue&type=script&lang=js"
export * from "./IntroduceBlock.vue?vue&type=script&lang=js"
import style0 from "./IntroduceBlock.vue?vue&type=style&index=0&id=6d6bd9af&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6bd9af",
  null
  
)

export default component.exports